import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { BonusGameDialogueView } from '../../view/bonus-game/BonusGameDialogueView';

export default function winHighlight(msg) {
	if (
		!msg &&
		GameConfigs.bonusRoundActivated === 'pending' &&
		GameConfigs.bonusBuy
	) {
		window.sm.play({ name: 'bell_sound_sfx' });
		setTimeout(() => {
			GameConfigs.bonusRoundActivated = 'init';
			HELPERS.dispatchCustomEvent(EVENTS.BONUS_ROUND_STATE, { state: 'init' });
			GameConfigs.uiComponent.addView(BonusGameDialogueView);
			GameConfigs.modal = 'bonus_game';
			HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: 'bonus_game' });
		}, 1500);
	}
}
